export default {
  state: {
    appVersion: null,
    newVersionAvailable: false,
  },
  mutations: {
    setVersion(state, version) {
      state.appVersion = version;
    },
    setNewVersionAvailable(state, hasNewVersion) {
      state.newVersionAvailable = hasNewVersion;
    },
  },
  actions: {
    updateVersion({ commit }, version) {
      commit('setVersion', version);
    },
    updateNewVersionAvailable({ commit }, hasNewVersion) {
      commit('setNewVersionAvailable', hasNewVersion);
    },
  },
  getters: {
    appVersion: state => state.appVersion,
    newVersionAvailable: state => state.newVersionAvailable,
  },
};
